import styled from 'styled-components';

export const ModalOverlay = styled.div``;

export const BpUnavailableContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & span {
    display: block;
  }
`;
